import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-006181ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ringingCallsContainer"
}

import { GetterTypes } from "@/store";
import { useComputedValue } from "@/composables";
import { FirestoreRingingCall } from "@/store/auth/types";
import RingingCallBanner from "../RingingCallBanner/RingingCallBanner.vue";
import { AppEnvironment, LayoutTypes } from "@/store/app/state";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RingingCallsContainer',
  setup(__props) {

const ringingCalls = useComputedValue<FirestoreRingingCall[]>(
  GetterTypes.GET_RINGING_CALLS,
);
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);
const isBannerShown = computed(
  () =>
    ringingCalls.value.length &&
    !environment.value.isMobileApp &&
    layoutType.value === LayoutTypes.DESKTOP,
);

return (_ctx: any,_cache: any) => {
  return (isBannerShown.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ringingCalls), (call) => {
          return (_openBlock(), _createBlock(RingingCallBanner, _mergeProps({
            key: call.chatId
          }, call), null, 16))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})